type SessionExpiredHandler = () => void;

let sessionExpiredHandler: SessionExpiredHandler | null = null;
let notifyingSessionExpiry = false;

export function setSessionExpiredHandler(
  handler: SessionExpiredHandler | null,
): void {
  sessionExpiredHandler = handler;
}

/**
 * Clears in-memory auth state when tokens are no longer valid.
 * Debounced so concurrent failed requests only trigger one logout.
 */
export function notifySessionExpired(): void {
  if (notifyingSessionExpiry) {
    return;
  }

  notifyingSessionExpiry = true;
  try {
    sessionExpiredHandler?.();
  } finally {
    window.setTimeout(() => {
      notifyingSessionExpiry = false;
    }, 1000);
  }
}
